import { SaleModel } from '../../../../../types.ts';
import { AuctionType } from '../../../../../../auctions/types.ts';
import { AuctionColorPicker } from '../../../../../utils/AuctionGradientPicker.tsx';
import { ApplicationRoutes } from '../../../../../../../constants/appRoutes.ts';
import { generateUrl } from '../../../../../../../constants/generateUrl.tsx';

export const useActiveAuctionCardContent = (model: SaleModel) => {
  const getButtonText = (saleType: AuctionType) => {
    switch (saleType) {
      case AuctionType.Timed:
        return 'Enter Timed Auction';
      case AuctionType.Event:
      case AuctionType.None:
        return 'Enter Live Event';
      default:
        return 'Enter Live Auction';
    }
  };

  const getSaleUrl = (saleType: AuctionType) => {
    switch (saleType) {
      case AuctionType.Timed:
        return model.ExternalSaleUrl;
      case AuctionType.Event:
        return generateUrl(ApplicationRoutes.liveAuction.event, { auctionId: String(model.Id) });
      default:
        return `${ApplicationRoutes.liveAuction.bidder}/${model.Id}`;
    }
  };

  return {
    description: model.SaleType === AuctionType.Timed ? [model.Name] : [model.Name, `Live From ${model.MarketName}`],
    saleTypeText: model.SaleTypeDisplayOverride || AuctionType[model.SaleType],
    saleDate: model.SaleDateTime,
    saleTimeZone: model.SaleTimeZone,
    buttonText: getButtonText(model.SaleType),
    badgeText: model.SaleType === AuctionType.Timed ? 'BIDDING OPEN' : undefined,
    color: AuctionColorPicker(model.SaleType),
    saleUrl: getSaleUrl(model.SaleType)
  };
};
